<template>
    <div id="main_app">
        <div class="main">
            <head-block v-if="!checkout"></head-block>
            <router-view></router-view>
        </div>
        <foot-block></foot-block>

        <navi v-if="navi"></navi>

        <coockies-subs></coockies-subs>
        <preloader v-if="preload"></preloader>

        <!--button for start/end preloader-->
        <div class="preload-btn text-center">
            <button
                    class="btn btn-green small"
                    @click="startPreload"
            >preload</button>
        </div>
        <!--button for start/end preloader-->


    </div>
</template>

<script>

    import HeadBlock from "./Partials/HeadBlock"
    import FootBlock from "./Partials/FootBlock"
    import navi from "./Partials/navi"
    import CoockiesSubs from "./Partials/CoockiesSubs"
    import preloader from "./preloader"


    export default {
        name: "App",
        components: {
            CoockiesSubs,
            FootBlock,
            HeadBlock,
            navi,
            preloader
        },
        data: function(){
            return {
                mode: process.env.NODE_ENV,
                navi: true,
                preload: false,
                checkout: false
            }
        },
        beforeCreate: function(){
          if(this.mode !== "development"){
              this.navi = false;
          }

        },
        methods: {
            startPreload(){
                this.preload = !this.preload;
            }
        },
        updated(){
            console.log(this.$route);
            if(this.$route.name === "checkoutNew"){
                this.checkout = true
            }

        }

    }
</script>
